<template>
  <div class="addPerson">
    <el-dialog
        title="添加人员"
        :visible.sync="dialogVisible"
        width="35%">
      <el-tabs v-model="activeName">
        <el-tab-pane label="内部人员" name="interior" v-if="showType === 'interior' || showType === 'all'">
          <interior ref="interior"></interior>
        </el-tab-pane>
        <el-tab-pane label="人员" name="external" v-if="showType === 'external' || showType === 'all'">
          <external ref="external"></external>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false" size="small">取 消</el-button>
    <el-button type="primary" @click="confirm" size="small" :loading="confirmLoading">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import interior from './interior'
import external from './external'
export default {
  name:'addPerson',

  props:['triggerUpdatePersonList'],

  data () {
    return {
      dialogVisible:false,
      showType:'all', //显示哪个页签，获取全部显示   //interior 内部 external 外部 all 全部,
      confirmLoading:false
    }
  },

  components : {
    interior,
    external
  },

  methods : {
    updateShowType (showType) {
      this.showType = showType
    },

    confirm () {
      let data = []
      if (this.showType === 'interior') {
        const interiorData = this.$refs.interior.checkData
        if (!interiorData[0]) return this.$message.warning('请选择内部人员')
        data = interiorData
      }

      if (this.showType === 'external') {
        const externalData = this.$refs.external.checkData
        if (!externalData[0]) return this.$message.warning('请选择外部人员')
        data = externalData
      }

      if (this.showType === 'all') {
        const interiorData = this.$refs.interior.checkData
        const externalData = this.$refs.external.checkData
        if (!externalData[0] && !interiorData[0]) return this.$message.warning('请选择人员')
        data = [...interiorData,...externalData]
      }
      this.confirmLoading = true
      this.triggerUpdatePersonList(data)
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    reset () {
      if (this.showType === 'interior') {
        this.$refs.interior.checkData = []
        this.$refs.interior.updateTreeKey = new Date().getTime()
      } else if (this.showType === 'external') {
        this.$refs.external.checkData = []
        this.$refs.external.updateTreeKey = new Date().getTime()
      } else {
        this.$refs.interior.checkData = []
        this.$refs.interior.updateTreeKey = new Date().getTime()
        this.$refs.external.checkData = []
        this.$refs.external.updateTreeKey = new Date().getTime()
      }

    }
  },

  computed : {
    activeName () {
      return this.showType === 'all' ? 'interior' : this.showType === 'interior' ? 'interior' : 'external'
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .addPerson
    /deep/ .el-dialog
              .el-dialog__body
                height 500px
                padding-top 0!important
                padding-bottom 0!important
               .el-tabs
                height 100%
                .el-tabs__header
                  margin-bottom 0
                  .el-tabs__active-bar
                    display none
                  .el-tabs__item
                    padding 0 20px!important
                    border-radius: 6px 6px 0px 0px;
                    font-weight normal!important
                    background #E9EDFA!important
                    margin-right 8px
                    font-size 14px!important
                  .is-active
                    color #fff!important
                    background #5584FF!important
                .el-tabs__content
                  height calc(100% - 40px)
                  .el-tab-pane
                    height 100%
</style>
